<template>
  <CCol>
    <CRow>
      <CCol sm="12"> </CCol>

      <CCol>
        <CRow class="justify-content-between align-items-center px-4">
          <CCol v-if="messages.length">
            <transition name="fade">
              <MenssageAlert :messages="messages" />
            </transition>
          </CCol>
          <CCol
            v-else
            v-for="channel in channels"
            :key="channel.id"
            @click="addNewChannel(channel.name)"
            sm="12"
            class="p-0 text-gray-600 cardChannel"
          >
            <div class="cardChannel__child p-3 m-1">
              <CIcon :name="channel.name.toLowerCase()" :height="25" viewBox="0 0 32 32" />

              <span class="font-weight-normal font-md text-center">
                {{ channel.name | removeCaracterSpecial }}
              </span>
            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  </CCol>
</template>

<script>
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'

export default {
  name: 'channels',
  components: {
    MenssageAlert
  },

  data() {
    return {
      loading: true,
      messages: [],
      channels: []
    }
  },

  mounted() {
    if (!this.channels.length) this.getChannels(this.$route.params.organizationId)
  },

  methods: {
    getChannels(organizationId) {
      this.loading = true
      if (this.$store.state.campaign.auxiliares.channels != null) {
        // Verifica se é um array válido
        if (Array.isArray(this.$store.state.campaign.auxiliares.channels)) {
          // Se o array não tiver itens, vai buscar novamente
          if (this.$store.state.campaign.auxiliares.channels.length > 0) {
            this.channels = [...this.$store.state.campaign.auxiliares.channels]
            return
          }
        }
      }

      services
        .getChannels(organizationId)
        .then(response => {
          this.channels = response.data.data
          this.$store.commit('campaign/UPDATE_AUXILIARES', { channels: [...response.data.data] })
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.Message || response.data.data.Message || 'Erro'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    addNewChannel(channel) {
      let organizationId = this.$store.state.auth.organizationId
      this.$store.dispatch('campaign/addNewChannel', channel.toUpperCase())
      this.$store.dispatch('campaign/saveCampaignId', this.$route.params.campaignId)
      this.$store.dispatch('campaign/savePathCampaign', {organizationId: organizationId, campaignId: this.$route.params.campaignId})
    }
  }
}
</script>
